import React from 'react'
import * as S from './styles'
import PropTypes from 'prop-types'

const Highlight = ({ type, children, outline, margin = 0 }) => {
  return (
    <S.Container aria-live='polite' type={type} outline={outline} margin={margin}>
      {children}
    </S.Container>
  )
}

Highlight.propTypes = {
  type: PropTypes.oneOf(['info', 'warning', 'error', 'success', 'outline', 'featured', 'disabled', 'pending']),
  outline: PropTypes.bool,
  children: PropTypes.node
}

export default Highlight
